import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

import { ERepair } from '../../../../../../../json_query';

export interface IRepairProps {
  repairs: ERepair[];
  onChange(value: ERepair[]): void;
}

export class Repair extends React.Component<IRepairProps> {
  public render() {
    return (
      <DropdownField
        multiple
        placeholder="Любой"
        value={this.getValue()}
        /* istanbul ignore next */
        onValueChange={this.props.onChange}
        /* istanbul ignore next */
        values={[
          { value: ERepair.Without, label: 'Без ремонта' },
          { value: ERepair.Cosmetic, label: 'Косметический' },
          { value: ERepair.Euro, label: 'Евроремонт' },
          { value: ERepair.Design, label: 'Дизайнерский' },
        ]}
      />
    );
  }

  private getValue = () => {
    const { repairs } = this.props;
    const result = [];

    if (repairs && repairs.length) {
      result.push(...repairs);
    }

    return result;
  };
}
